// TODO:
// ADD LIGHTBOX
class MainProductSliderWithThumbnails extends HTMLElement {
  constructor() {
    super();
    this.variantSelector = document.querySelector("variant-selects");
    this.slideCustomEvent = null;
  }

  connectedCallback() {
    this.loadMainSliderElements();
    this.loadThumbnailsElements();
    this.buildSlider();
    this.enableDesktopZoom();
    this.bindGalleryHeightSync();

    this.activeFilter = {
      owner: "default",
      altKey: null,
    };
    this.isHoverPreview = false;

    document.addEventListener(
      "product:variant-change",
      this.variantChangeEventHandler.bind(this),
    );
    window.addEventListener(
      "bundle:change",
      this.bundleChangeEventHandler.bind(this),
    );
    this.enableSwatchHoverPreview();
    this.scrollBtn?.addEventListener("click", () => {
      this.thumbnailContainer.scrollTop = this.thumbnailContainer.scrollHeight;
    });
  }

  disconnectedCallback() {
    if (this._syncGalleryHeight) {
      window.removeEventListener("resize", this._syncGalleryHeight);
    }
    if (this._galleryResizeObserver) {
      this._galleryResizeObserver.disconnect();
    }
    this.thumbnailContainer?.removeEventListener(
      "click",
      this.thumbnailEventHandler.bind(this),
    );
  }

  bindGalleryHeightSync() {
    if (!this.closest(".main-product-2026") || !this.mainSlider?.options.adaptiveHeight) {
      return;
    }

    this._syncGalleryHeight = () => {
      window.requestAnimationFrame(() => {
        if (!this.mainSlider) return;
        this.mainSlider.resize();
        this.mainSlider.adaptiveHeight();
        this._syncMobileThumbnailHeights();
      });
    };

    window.addEventListener("resize", this._syncGalleryHeight);

    this.mainSliderElement.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener("load", this._syncGalleryHeight, { once: true });
    });

    if (typeof ResizeObserver !== "undefined") {
      this._galleryResizeObserver = new ResizeObserver(this._syncGalleryHeight);
      this._galleryResizeObserver.observe(this.mainSliderElement);
      const viewport = this.mainSliderElement.querySelector(".flickity-viewport");
      if (viewport) this._galleryResizeObserver.observe(viewport);
    }

    this._syncGalleryHeight();
  }

  _getMainGalleryHeight() {
    const viewport = this.mainSliderElement?.querySelector(".flickity-viewport");
    if (viewport?.offsetHeight) return viewport.offsetHeight;
    return this.mainSliderElement?.offsetHeight || 0;
  }

  _syncMobileThumbnailHeights() {
    const galleryRoot = this.querySelector("#main-product--slider-with-thumbnails");
    const thumbWrap = this.querySelector(".slider-with-thumbnails--thumbnails-wrap");
    if (!galleryRoot || !thumbWrap || !this.closest(".main-product-2026")) return;

    if (!window.matchMedia("(max-width: 1023px)").matches) {
      galleryRoot.style.removeProperty("--pdp-gallery-main-height");
      thumbWrap.style.removeProperty("height");
      thumbWrap.style.removeProperty("max-height");
      this.thumbnailContainer?.style.removeProperty("max-height");
      return;
    }

    const height = this._getMainGalleryHeight();
    if (height > 0) {
      galleryRoot.style.setProperty("--pdp-gallery-main-height", `${height}px`);
      thumbWrap.style.height = `${height}px`;
      thumbWrap.style.maxHeight = `${height}px`;
      if (this.thumbnailContainer) {
        this.thumbnailContainer.style.maxHeight = `${height}px`;
      }
    }
  }

  loadMainSliderElements() {
    this.mainSliderElement = this.querySelector(
      "#slider-with-thumbnails--main-slider",
    );

    this.mainSliderSlides = Array.from(
      this.mainSliderElement.querySelectorAll(".slider-with-thumbnails--slide"),
    );

    const defaultActiveVariant = this.mainSliderElement.querySelector(
      `[data-is-image-for-active-variant="true"]`,
    );
    defaultActiveVariant.parentElement.prepend(defaultActiveVariant);

    this.mainSliderElement.addEventListener("click", (event) => {
      const slide = event.target.closest(".slider-with-thumbnails--slide");
      if (!slide) return;
      const { mainSlideId } = slide.dataset;
      this.zoomSlide(mainSlideId);
    });

    this.querySelector("#main-slider--zoom-icon").addEventListener(
      "click",
      () => {
        const slide = this.mainSliderElement.querySelector(
          ".slider-with-thumbnails--slide.is-selected",
        );
        if (!slide) return;
        const { mainSlideId } = slide.dataset;
        this.zoomSlide(mainSlideId);
      },
    );
  }

  loadThumbnailsElements() {
    this.thumbnailContainer = this.querySelector(
      "#slider-with-thumbnails--thumbnails",
    );

    this.thumbnailContainer.addEventListener(
      "click",
      this.thumbnailEventHandler.bind(this),
    );

    const defaultActiveVariant = this.thumbnailContainer.querySelector(
      `[data-thumbnail-active="true"]`,
    );
    defaultActiveVariant.parentElement.prepend(defaultActiveVariant);

    this.scrollBtn = this.querySelector(
      "#slider-with-thumbnails--thumbnails-scroll-btn",
    );
  }

  getVariantAltKey(variant) {
    return (
      variant?.featured_image?.alt?.toLowerCase() ||
      variant?.featured_media?.alt?.toLowerCase() ||
      ""
    );
  }

  enableSwatchHoverPreview() {
    const root =
      this.closest(".main-product-2026") ||
      this.closest(".thb-product-detail") ||
      document;
    const variantSelects = root.querySelector("variant-selects");
    if (!variantSelects) return;

    const colorFieldsets = root.querySelectorAll(
      "fieldset.main-product-2026__variant--swatch, fieldset.product-form__input--color, fieldset.main-product-2026__variant--pill",
    );
    if (!colorFieldsets.length) return;

    const getVariantData = () => {
      try {
        return JSON.parse(
          variantSelects.querySelector('[type="application/json"]').textContent,
        );
      } catch {
        return [];
      }
    };

    const getCurrentOptions = () =>
      Array.from(variantSelects.querySelectorAll("fieldset")).map(
        (fieldset) => {
          const select = fieldset.querySelector("select");
          if (select) return select.value;
          const checked = fieldset.querySelector("input:checked");
          return checked ? checked.value : "";
        },
      );

    const previewFromInput = (input) => {
      if (this.activeFilter?.owner && this.activeFilter.owner !== "default")
        return;

      const fieldsets = Array.from(variantSelects.querySelectorAll("fieldset"));
      const hoverFieldset = input.closest("fieldset");
      const hoverIndex = fieldsets.indexOf(hoverFieldset);
      if (hoverIndex < 0) return;

      const hoverOptions = getCurrentOptions();
      hoverOptions[hoverIndex] = input.value;

      const variant = getVariantData().find(
        (v) =>
          !v.options
            .map((opt, idx) => hoverOptions[idx] === opt)
            .includes(false),
      );
      if (!variant) return;

      this.isHoverPreview = true;
      this.activeFilter = {
        owner: "default",
        altKey: this.getVariantAltKey(variant),
      };
      this.applyFilter(this.activeFilter);
    };

    const restoreSelectedVariant = () => {
      if (!this.isHoverPreview) return;
      if (this.activeFilter?.owner && this.activeFilter.owner !== "default")
        return;

      this.isHoverPreview = false;
      const variantAlt = this.getVariantAltKey(variantSelects.currentVariant);
      this.activeFilter = { owner: "default", altKey: variantAlt };
      this.applyFilter(this.activeFilter);
    };

    colorFieldsets.forEach((fieldset) => {
      const swatchContainer =
        fieldset.querySelector(".main-product-2026__swatches") ||
        fieldset.querySelector(".main-product-2026__pills") ||
        fieldset;

      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = swatchContainer.querySelector(`label[for="${input.id}"]`);
        const target = label || input;
        target.addEventListener("mouseover", () => previewFromInput(input));
      });

      swatchContainer.addEventListener("mouseleave", restoreSelectedVariant);
    });
  }

  async variantChangeEventHandler(event) {
    if (this.activeFilter?.owner && this.activeFilter.owner !== "default")
      return;
    this.isHoverPreview = false;
    const variantAlt = this.getVariantAltKey(event.detail.variant);
    this.activeFilter = { owner: "default", altKey: variantAlt };
    this.applyFilter(this.activeFilter);
  }
  thumbnailEventHandler(event) {
    const thumbnail = event.target.closest(".thumbnail");
    if (!thumbnail) return;

    const { thumbnailId } = thumbnail.dataset;

    const prevActiveThumbnail = this.thumbnailContainer.querySelector(
      `.thumbnail[data-thumbnail-active="true"]`,
    );
    if (prevActiveThumbnail)
      prevActiveThumbnail.dataset.thumbnailActive = false;

    thumbnail.dataset.thumbnailActive = true;

    const targetCell = this.mainSliderElement.querySelector(
      `[data-main-slide-id="${thumbnailId}"]`,
    );
    if (!targetCell || !this.mainSlider) return;

    const cellIndex = this.mainSlider.cells.findIndex(
      (c) => c.element === targetCell,
    );
    if (cellIndex >= 0) this.mainSlider.select(cellIndex);
  }

  filterThumbnails(variantAlt) {
    this.thumbnailContainer.querySelectorAll(".thumbnail").forEach((el) => {
      let { thumbnailAlt } = el.dataset;
      let thumbnailIncludesVariantAlt = thumbnailAlt.includes(variantAlt);
      el.dataset.thumbnailFiltered = thumbnailIncludesVariantAlt;
      el.dataset.thumbnailActive = false;
      if (thumbnailAlt === variantAlt) {
        el.dataset.thumbnailActive = true;
        el.parentElement.prepend(el);
      }
    });

    this.thumbnailContainer.scrollTop = 0;
  }

  applyFilter({ owner, altKey }) {
    this.filterThumbnailsByOwnerAndAlt(owner, altKey);
    this.filterMainSliderByOwnerAndAlt(owner, altKey);
  }
  filterThumbnailsByOwnerAndAlt(owner, altKey) {
  const thumbs = Array.from(
    this.thumbnailContainer.querySelectorAll(".thumbnail"),
  );

  const isBundleOwnerMode = owner !== "default";

  let firstExactMatch = null;
  let firstVisible = null;

  thumbs.forEach((el) => {
    const thumbOwner = el.dataset.mediaOwner || "default";
    const thumbAlt = (el.dataset.thumbnailAlt || "").toLowerCase();

    const ownerOk = thumbOwner === owner;
    const altOk = altKey ? (thumbAlt.includes(altKey) || thumbAlt.includes('shared')) : true;

    const visible = ownerOk && altOk;

    el.dataset.thumbnailFiltered = visible;
    el.dataset.thumbnailActive = false;

    if (visible && !firstVisible) firstVisible = el;

    // Track the FIRST exact alt match only (prevents flip-flop ordering)
    if (visible && altKey && thumbAlt === altKey && !firstExactMatch) {
      firstExactMatch = el;
    }
  });

  // Decide active thumb (prefer exact match, else first visible)
  const activeThumb = firstExactMatch || firstVisible;
  if (activeThumb) {
    activeThumb.dataset.thumbnailActive = true;

    // Only default mode should reorder to bring active to top
    if (!isBundleOwnerMode) {
      activeThumb.parentElement.prepend(activeThumb);
    }
  }

  this.thumbnailContainer.scrollTop = 0;
}


  filterMainSliderByOwnerAndAlt(owner, altKey) {
    if (this.mainSlider && typeof this.mainSlider.destroy === "function") {
      this.mainSlider.destroy();
    }

    this.mainSliderSlides.forEach((el) => {
      const slideOwner = el.dataset.mediaOwner || "default";
      const slideAlt = (el.dataset.mainSlideAlt || "").toLowerCase();

      const ownerOk = slideOwner === owner;
      // Updated logic: Check for exact variant match OR the "shared" keyword
      const altOk = altKey ? (slideAlt.includes(altKey) || slideAlt.includes("shared")) : true;

      if (ownerOk && altOk) el.classList.add("filtered-slide");
      else el.classList.remove("filtered-slide");
    });

    this.buildSlider();

    // force Flickity to measure correctly after filtering
    requestAnimationFrame(() => {
      if (!this.mainSlider) return;
      this.mainSlider.reloadCells();
      this.mainSlider.resize();
      this.mainSlider.select(0, false, true);
      if (this.mainSlider.options.adaptiveHeight) {
        this.mainSlider.adaptiveHeight();
        this._syncMobileThumbnailHeights();
      }
      this.enableDesktopZoom();
    });
  }

  buildSlider() {
    const is2026Pdp = !!this.closest(".main-product-2026");
    this.mainSlider = new Flickity("#slider-with-thumbnails--main-slider", {
      contain: true,
      pageDots: true,
      cellAlign: "left",
      prevNextButtons: false,
      cellSelector: ".filtered-slide",
      adaptiveHeight: is2026Pdp,
    });

    if (is2026Pdp) {
      this.mainSlider.on("settle", () => this._syncMobileThumbnailHeights());
      this.mainSlider.on("change", () => {
        requestAnimationFrame(() => {
          if (!this.mainSlider) return;
          this.mainSlider.adaptiveHeight();
          this._syncMobileThumbnailHeights();
        });
      });
      requestAnimationFrame(() => {
        if (!this.mainSlider) return;
        this.mainSlider.resize();
        this.mainSlider.adaptiveHeight();
        this._syncMobileThumbnailHeights();
      });
    }
  }

  zoomSlide(mainSlideId) {
    // only enable on mobile
    if (window.innerWidth > 768) return;
    this.slideCustomEvent = new CustomEvent(
      "product-slider-with-thumbnail:slide-clicked",
      {
        detail: {
          mainSlideId,
        },
      },
    );
    window.dispatchEvent(this.slideCustomEvent);
  }
  enableDesktopZoom() {
    // Only enable on desktop
    if (window.innerWidth < 769) return;
    // or use matchMedia if you want a dynamic approach

    // Grab all product__zoom-container elements from your slider area
    const zoomContainers = this.mainSliderElement.querySelectorAll(
      ".slider-with-thumbnails--slide .product__zoom-container",
    );

    // For each container, add event listeners for click & mousemove
    zoomContainers.forEach((container) => {
      // When user clicks, toggle zoom-visible
      container.addEventListener("click", () => {
        container.classList.toggle("zoom-visible");
        // Reset background-position so it doesn’t jump from old position
        container.style.backgroundPosition = "center";
      });

      // Follow cursor only if zoom is active
      container.addEventListener("mousemove", (event) => {
        if (!container.classList.contains("zoom-visible")) return;

        const rect = container.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const offsetY = event.clientY - rect.top;

        const xPercent = (offsetX / rect.width) * 100;
        const yPercent = (offsetY / rect.height) * 100;

        container.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
      });
    });
  }

  bundleChangeEventHandler(event) {
    const { type, owner } = event.detail || {};
    const normalizedOwner = owner || "default";

    if (type === "bundle" && normalizedOwner !== "default") {
      // bundle thumbs/slides use: data-*-alt="bundle-{{ owner }}"
      const bundleAltKey =
        `bundle-${normalizedOwner.replace(/^bundle:/, "")}`.toLowerCase();

      this.activeFilter = { owner: normalizedOwner, altKey: bundleAltKey };
      this.applyFilter(this.activeFilter);
      return;
    }

    // fallback to default mode: filter by current variant alt
    const currentVariant = this.variantSelector?.currentVariant;
    const variantAlt =
      currentVariant?.featured_image?.alt?.toLowerCase() ||
      currentVariant?.featured_media?.alt?.toLowerCase() ||
      "";

    this.activeFilter = { owner: "default", altKey: variantAlt };
    this.applyFilter(this.activeFilter);
  }
}

class MainProductSliderWithThumbnailsLightbox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Keep the modal at document root so position:fixed is viewport-relative
    // and a closed overlay cannot trap clicks inside sticky gallery columns.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.container = this.querySelector(
      "#main-product-slider-with-thumbnails-lightbox-container",
    );

    this.slider = this.querySelector(
      "#main-product-slider-with-thumbnails-lightbox-slider",
    );

    this.closeBtn = this.querySelector(
      "#close-product-slider-with-thumbnails-lightbox",
    );

    this.addEventListener("click", this.componentClickEventHandler.bind(this));

    window.addEventListener(
      "product-slider-with-thumbnail:slide-clicked",
      this.productSlideClickHandler.bind(this),
    );

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
  }

  componentClickEventHandler(event) {
    const closeBtn = event.target.closest(
      "#close-product-slider-with-thumbnails-lightbox",
    );

    const nextSlideBtn = event.target.closest(
      "#next-slide-product-slider-with-thumbnails-lightbox",
    );

    const prevSlideBtn = event.target.closest(
      "#prev-slide-product-slider-with-thumbnails-lightbox",
    );

    if (closeBtn) {
      this.closeLightbox();
      return;
    }

    if (nextSlideBtn) {
      this.scrollSlider("next");
      return;
    }

    if (prevSlideBtn) {
      this.scrollSlider("prev");
      return;
    }

    this.closeLightbox();
  }

  productSlideClickHandler(event) {
    const { mainSlideId } = event.detail;
    this.openLightbox();
    this.scrollSlideIntoView(mainSlideId);
  }

  scrollSlideIntoView(mainSlideId) {
    const lightboxSlide = this.slider.querySelector(
      `.main-product-slider-with-thumbnails-lightbox-slide[data-media-id="${mainSlideId}"]`,
    );

    const lightboxSlidePosition =
      lightboxSlide.offsetLeft - this.slider.offsetLeft;

    this.slider.scrollTo({
      left: lightboxSlidePosition,
      behavior: "smooth",
    });
  }

  scrollSlider(action) {
    const refSlide = this.slider.children[0].offsetWidth;

    switch (action) {
      case "next":
        this.slider.scrollBy({ left: refSlide, behavior: "smooth" });
        break;
      case "prev":
        this.slider.scrollBy({ left: -refSlide, behavior: "smooth" });
        break;
      default:
        break;
    }
  }

  openLightbox() {
    this.container.dataset.showProductSliderWithThumbnailsLightbox = true;
  }

  closeLightbox() {
    this.container.dataset.showProductSliderWithThumbnailsLightbox = false;
  }
}

customElements.define(
  "main-product-slider-with-thumbnails",
  MainProductSliderWithThumbnails,
);

customElements.define(
  "main-product-slider-with-thumbnails-lightbox",
  MainProductSliderWithThumbnailsLightbox,
);
